<template>
    <div v-if="loaded">
        <card-header icon="fa-file-certificate" :title="application.title"/>

        <card-body>
            <application-view :application="application" :applicant="applicant"></application-view>
        </card-body>

        <card-footer>
            <div class="columns">
                <div class="column">
                    <b-button type="is-danger" size="is-small" class="m-2" @click="reject()" disabled>
                        <b-icon icon="times" class="mr-2"></b-icon>
                        Reject
                    </b-button>
                </div>
                <div class="column">
                    <div class="is-pulled-right">
                        <b-button type="is-success" size="is-small" class="m-2" @click="approve()">
                            <b-icon icon="check" class="mr-2"></b-icon>
                            Approve
                        </b-button>
                    </div>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import RenderComponent from "@/components/RenderComponent";

    import {client as http} from "@/http_client";
    import CardFooter from "../../TIER/components/CardFooter";
    import CardList from "../../TIER/components/CardList";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import ContainerListItem from "../../TIER/components/ContainerListItem";
    import DataRow from "../../TIER/components/DataRow";
    import moment from "moment";
    import SeparatorListItem from "../../TIER/components/SeparatorListItem";
    import CardListItem from "../../TIER/components/CardListItem";
    import async from "async";
    import ApplicationView from "../applications/applicants/ApplicationView.vue";

    export default {
        components: {ApplicationView, CardListItem, SeparatorListItem, DataRow, ContainerListItem, SubheaderListItem, CardList, CardFooter, RenderComponent, CardBody, CardHeader},
        props: ['card', 'props'],
        data: function() {
            return {
                applicant: null,
                application: null,
                loaded: false,
            };
        },
        computed: {
            confDates: function() {
                let s = moment(this.conf.conference.start_at);
                let e = moment(this.conf.conference.end_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMMM D, YYYY');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMMM D - ') + e.format('D, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D - ') + e.format('MMM D, YYYY');
                } else {
                    return s.format('MMM D, YYYY - ') + e.format('MMM D, YYYY');
                }
            },
        },
        methods: {
            loadReview: function() {
                this.$emit('loading', true);
                async.series([
                    // get applicant
                    (cb) => {
                        http.get('/applicants/course/' + this.props.reviewId, {force: true}).then(response => {
                            this.applicant = response.data;
                            cb()
                        }).catch(err => {
                            cb(err);
                        });
                    },
                    // get application
                    (cb) => {
                        http.get('applications/' + this.applicant.course_applications.application_id, {force: true}).then(response => {
                            if (!response.data.outline) response.data.outline = [];
                            this.application = response.data;
                            cb()
                        }).catch(err => {
                            cb(err);
                        });
                    }
                ], err => {
                    this.$emit('loading', false);
                    this.loaded = true;
                });
            },
            approve() {
                this.$emit('loading', true);
                http.post('/applications/approveEnroll/', {id: this.props.reviewId}).then(response => {
                    this.$closeCard(this.card);
                    this.$reloadCard('reviews');
                }, err => {
                    console.log(err);
                });
            },
            reject() {
                this.$emit('loading', true);
                http.post('/applications/reject/', {id: this.props.reviewId}).then(response => {
                    this.$closeCard(this.card);
                    this.$reloadCard('reviews');
                }, err => {
                    console.log(err);
                });
            },
            // getData(conf, field) {
            //     for (let i = 0; i < this.conf.config.data.length; i++) {
            //         const datum = this.conf.config.data[i];
            //         if (datum.field === field) {
            //             return JSON.parse(datum.value);
            //         }
            //     }
            // },
            displayDates: function(start, end) {
                let s = moment(start);
                let e = moment(end);
                if (s.isSame(e, 'day')) {
                    return s.format('dddd, MMMM Do, h:mm A') + ' - ' + e.format('h:mm A');
                } else {
                    return s.format('MMM Do, h:mm A') + ' - ' + e.format('MMM Do, h:mm A');
                }
            },
        },
        watch: {
            'props.reviewId': function() {
                this.loadReview();
            }
        },
        mounted: function() {
            this.loadReview();
        }
    };
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .component-content {
        margin: 2rem 0;
    }
</style>
